"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3193],{

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(637);
/* harmony import */ var _context_objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1563);
/* harmony import */ var _public_images_logo_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6694);





var Footer = function(param) {
    var region = param.region, seo = param.seo;
    var locationState = (0,_context_location__WEBPACK_IMPORTED_MODULE_2__/* .useLocationState */ .KJ)();
    var setObjectsState = (0,_context_objects__WEBPACK_IMPORTED_MODULE_3__/* .useObjectsDispatch */ .U_)();
    if (!region && locationState.code) region = locationState.code;
    if (region == undefined || region == "") region = "krasnodarskiy_kray";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "footer",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "top",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "socials",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://t.me/baza_estate",
                                className: "telegram no-animation",
                                title: "Telegram",
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: [
                                "/",
                                region ? region + "/" : ""
                            ].join(""),
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "logo",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_images_logo_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "middle",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            children: [
                                " Продажа",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "submiddle",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/buy/flats/1k"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "продажа",
                                                                category: "квартира",
                                                                rooms: [
                                                                    "1"
                                                                ]
                                                            }
                                                        });
                                                    },
                                                    children: "Однокомнатные квартиры"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/buy/flats/2k"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "продажа",
                                                                category: "квартира",
                                                                rooms: [
                                                                    "2"
                                                                ]
                                                            }
                                                        });
                                                    },
                                                    children: "Двухкомнатные квартиры"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/buy/flats/3k"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "продажа",
                                                                category: "квартира",
                                                                rooms: [
                                                                    "3"
                                                                ]
                                                            }
                                                        });
                                                    },
                                                    children: "Трехкомнатные квартиры"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/buy/rooms"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "продажа",
                                                                category: "комната"
                                                            }
                                                        });
                                                    },
                                                    children: "Комнаты"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/buy/houses"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "продажа",
                                                                category: "дом"
                                                            }
                                                        });
                                                    },
                                                    children: "Домовладения"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/buy/sites"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "продажа",
                                                                category: "участок"
                                                            }
                                                        });
                                                    },
                                                    children: "Земельные участки"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/buy/commercial"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "продажа",
                                                                category: "коммерция"
                                                            }
                                                        });
                                                    },
                                                    children: "Коммерческая недвижимость"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            children: [
                                " Аренда",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "submiddle",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/rent/flats/1k"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "аренда",
                                                                category: "квартира",
                                                                rooms: [
                                                                    "1"
                                                                ]
                                                            }
                                                        });
                                                    },
                                                    children: "Однокомнатные квартиры"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/rent/flats/2k"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "аренда",
                                                                category: "квартира",
                                                                rooms: [
                                                                    "2"
                                                                ]
                                                            }
                                                        });
                                                    },
                                                    children: "Двухкомнатные квартиры"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/rent/flats/3k"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "аренда",
                                                                category: "квартира",
                                                                rooms: [
                                                                    "3"
                                                                ]
                                                            }
                                                        });
                                                    },
                                                    children: "Трехкомнатные квартиры"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/rent/rooms"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "аренда",
                                                                category: "комната"
                                                            }
                                                        });
                                                    },
                                                    children: "Комнаты"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/rent/houses"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "аренда",
                                                                category: "дом"
                                                            }
                                                        });
                                                    },
                                                    children: "Домовладения"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/rent/sites"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "аренда",
                                                                category: "участок"
                                                            }
                                                        });
                                                    },
                                                    children: "Земельные участки"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "objects/rent/commercial"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onClick: function() {
                                                        return setObjectsState({
                                                            type: "SET_FILTER",
                                                            payload: {
                                                                type: "аренда",
                                                                category: "коммерция"
                                                            }
                                                        });
                                                    },
                                                    children: "Коммерческая недвижимость"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            children: [
                                " Полезное",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "submiddle",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "buildings"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: "Новостройки"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: [
                                                    "/",
                                                    region ? region + "/" : "",
                                                    "add"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: "Добавить объект"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: "/xml",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: "Подключить фид"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: "/faq/policy",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: "Политика конфиденциальности"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                seo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "seo",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: seo
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ })

}]);